<template>
  <v-dialog v-model="show" :width="450" persistent>
    <v-card>
      <v-card-title class="pb-0">
        <div class="add-on-heading">
          <div class="add-on-title txt-bold itoviEden--text" style="font-size: 24px;">Manage People</div>
          <span flat icon color="itoviGrayMid" @click="close()"><v-icon>close</v-icon></span>
        </div>
      </v-card-title>
      <div v-if="activeClient === null" class="pl-4 pr-4 itoviGrayText--text" style="background: #F4F5F5;">Contacts ({{ plusOneClients.clients.length + plusOneClients.open_slots }})</div>
      <v-card-text class="pt-0 pl-2 pr-2 pb-0 text-xs-left" v-if="activeClient === null">
        <v-list class="pa-0">
          <template v-for="(client, index) in plusOneClients.clients" >
            <v-list-tile
                class="pa-0 pb-2 pt-2"
                :key="client.title"
                avatar
                two-line
                @click="setActiveClient(index)"
            >
              <v-list-tile-content class="pa-0">
                <v-list-tile-title class="font-weight-bold itoviDune--text">{{ client.name }}</v-list-tile-title>
                <v-list-tile-title v-if="client.expires_on" class="error--text">(Pending Removal)</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon>
                  <v-icon color="itoviPrimary">chevron_right</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider :key="index" v-if="plusOneClients.clients.length !== index + 1 || plusOneClients.open_slots" />
          </template>
          <template v-for="index in plusOneClients.open_slots">
            <v-list-tile
                class="pa-0 pt-2 pb-2"
                avatar
                :key="`${index}-openSlot`"
                two-line
                @click="planSize > 0 ? setActiveClient(-1) : null"
            >
              <v-list-tile-content class="pa-0 itoviGrayText--text">
                <v-list-tile-title class="font-weight-bold">Unassigned</v-list-tile-title>
                <v-list-tile-title>Go to the app to assign a contact</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon :disabled="planSize === 0">
                  <v-icon color="itoviPrimary">chevron_right</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider :key="index" v-if="plusOneClients.open_slots !== index" />
          </template>
        </v-list>
      </v-card-text>
      <v-card-text class="pa-0 text-xs-left" v-else >
        <v-layout class="pt-3 pb-3" row align-center style="box-shadow: 0px 0px 3px 0px #00000029; background: #FAFAFA;">
          <v-flex xs2>
            <v-btn icon ripple>
              <v-icon large @click="activeClient = null" color="itoviPrimary">chevron_left</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs8>
            <v-layout column align-center justify-center>
              <v-flex>
                <v-avatar
                    :tile="false"
                    size="60"
                >
                  <img :src="getClientAvatar()" alt="avatar" />
                </v-avatar>
              </v-flex>
              <v-flex class="txt-bold mt-1">{{ activeClient.name }}</v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2></v-flex>
        </v-layout>
        <v-card-text class="mt-2">
          <v-layout column align-center>
            <v-flex v-if="activeClient.expires_on" class="error--text txt-bold">(Pending Removal)</v-flex>
            <v-flex v-if="activeClient.expires_on" class="error--text text-sm-center mb-3">
              They will be removed from your contacts and unable to receive scans starting {{ moment(activeClient.expires_on).format('MM/DD/YYYY') }}
            </v-flex>
            <v-flex v-if="activeClient.date_created">Contact Created: {{ moment(activeClient.date_created.date).format('MM/DD/YYYY')}}</v-flex>
            <v-flex v-if="activeClient.id === -1">Contact is unassigned, go to iTOVi app to assign a person</v-flex>
          </v-layout>
        </v-card-text>
        <v-layout row justify-center align-center class="pt-3 pb-3" style="box-shadow: 0px 0px 3px 0px #00000029; background: #FAFAFA;">
          <button :class="activeClient.expires_on ? 'button-blue' : 'button-red-outline'" @click="setConfirmClient()" v-if="activeClient.expires_on || planSize > 0">
            {{ activeClient.expires_on ? 'Reactivate Contact' : ' Remove Contact' }}
          </button>
        </v-layout>
      </v-card-text>
    </v-card>
    <confirm-plus-one-client :confirmClient.sync="confirmClient" :fetchData="fetchData" :activeClient.sync="activeClient" />
  </v-dialog>
</template>

<script>
  import avatarPlaceholder from "@/assets/images/blank_avatar.svg";
  import moment from 'moment';
  import ConfirmPlusOneClient from "@/components/dashboard/yourPlanCard/ConfirmPlusOneClient";
  import store from "@/store";
  import subscribeToStore from "@/mixins/subscribeToStore";

  export default {
    components: {
      ConfirmPlusOneClient
    },
    data: ()=> ({
      plusOneClients: store.state.plusOneClients,
      confirmClient: {
        show: false,
        client: null
      },
      activeClient: null,
      unassignedClient : { id: -1, name: 'Unassigned', avatar: [], expires_on: null }
    }),
    props: [
      'show',
      'fetchData',
      'planSize'
    ],
    mixins: [subscribeToStore],
    mounted() {
      this.subscribeToStore(['plusOneClients']);
    },
    methods: {
      moment:moment,
      setActiveClient(index = 0) {
        if (index === -1) return this.activeClient = this.unassignedClient;
        return this.activeClient = this.plusOneClients.clients[index];
      },
      getClientAvatar() {
        let avatar = this.activeClient.avatar[0];
        return avatar ? avatar.url : avatarPlaceholder;
      },
      setConfirmClient() {
        this.confirmClient = {
          show: true,
          client: this.activeClient
        }
      },
      close() {
        this.activeClient = null;
        this.$emit('update:show',false)
      }
    }
  }

</script>
